import { AppId } from '@inno-tools/container-bridge'
import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { containerApi } from '../..'
import { PinAppResponse } from './pinApp.types'

export const pinApp = async (appId: AppId) => {
  const response = await containerApi.post<PinAppResponse>(
    `/desktop/pinned-apps/${appId}`
  )
  return response.data
}

export const usePinAppMutation = (
  options?: ExtendableMutationOptions<PinAppResponse, AppId>
) => {
  return useMutation({
    mutationFn: pinApp,
    ...options
  })
}
